
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import { PropTypes } from 'prop-types';
import { Carousel } from 'react-responsive-carousel';

const Slider = ({ imgs }) => {
    return (
        <Carousel
            showThumbs={false}
            showStatus={false}
            infiniteLoop={true}
            renderArrowNext={
                (onClickHandler, hasNext, label) => {
                    return (
                        <button
                            type="button"
                            onClick={onClickHandler}
                            title={label}
                            className="absolute right-0 top-1/2 z-10 text-white bg-black bg-opacity-30 rounded-full mx-2  flex items-center justify-center"

                        >
                            <MdChevronRight size={50} />
                        </button>
                    );
                }
            }
            
            renderArrowPrev={
                (onClickHandler, hasNext, label) => {
                    return (
                        <button
                            type="button"
                            onClick={onClickHandler}
                            title={label}
                            className="absolute left-0 top-1/2 z-10 text-white bg-black bg-opacity-30 rounded-full mx-2  flex items-center justify-center"

                        >
                            <MdChevronLeft size={50} />
                        </button>
                    );
                }
            }
        >
            {
                imgs?.map((img, index) => {
                    return (
                        <div className="lg:h-[30rem]" key={index}>
                            <img className="max-w-full h-auto object-cover" alt="photo" src={img} />
                        </div>
                    )
                })
            }
        </Carousel>
    )
}
Slider.propTypes = {
    imgs: PropTypes.array
}
export default Slider